module.exports = " <div class=block__footer><hr> <span class=item-count>Total: {{itemsCount}} items</span> <span>Items per page:</span> <select class=\"select block__footer__select\" v-model=itemsPerPage @change=perPageChange> <option :value=value v-for=\"value in perPage\">{{value}}</option> </select> <div class=pagination> <button class=\"icon-button prev-green\" @click=prev></button> <span>{{pageNumber + 1}} / {{pageCount}}</span> <button class=\"icon-button next-green\" @click=next></button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/shared/Paginator.vue
// module id = 173
// module chunks = 0